import React, { useEffect, useState } from "react"
import { Heading } from "cai-fusion";
import { useNewTemplate } from "../../contexts/NewTemplateContext";
import { useUserProfile } from "../../contexts/UserProfileContext";
import { useSettings } from "../../contexts/SettingsContext";
import { FormField } from "../../common/formFields";
import { usePromptEditor } from "../hooks/usePromptEditor";
import TagsEditor from "../components/TagsEditor";
import AdvancedSettings from "../components/AdvancedSettings";
import { debugLog } from "../../../../configs/loggingConfig";

const TemplateBasics = () => {
    const { 
        preparePlaceholderTemplate, 
        chatTemplate, 
        setChatTemplate,
        trackPropertyChange,
        originalTemplate 
    } = useNewTemplate();
    const { userProfile } = useUserProfile();
    const { models, settings } = useSettings();

    // A state to help with proper loading.
    const [formIsPrepared, setFormIsPrepared] = useState(false);

    // Use the extracted prompt editor hook
    const { prompt, updatePrompt } = usePromptEditor(chatTemplate, setChatTemplate);

    useEffect(() => {
        if (!formIsPrepared && settings.length !== 0 && models.length !== 0) {
            debugLog.log("ready!");
            setFormIsPrepared(true);
        }
    }, [models, settings])

    // For updating generic data input fields, this function is called.
    const updateData = (e) => {
        // Replace the field given with the changed value
        setChatTemplate({ ...chatTemplate, [e.target.id]: e.target.value })
    }

    // For updating checkbox-like fields, this function is called instead of the above.
    const updateCheckbox = (e) => {
        setChatTemplate({ ...chatTemplate, [e.target.id]: e.target.checked })
    }

    const updateModelParameters = (modelParameterId, modelId, value) => {
        let tempModelParameters = [...chatTemplate?.modelParameters] || [];
        // Find the parameter by its ID, not by index
        const paramIndex = tempModelParameters.findIndex(
            p => p.modelParameterId === modelParameterId && p.modelId === modelId
        );
        
        if (paramIndex !== -1) {
            // Parse to number to ensure correct data type
            tempModelParameters[paramIndex].value = parseFloat(value);
            setChatTemplate({ ...chatTemplate, modelParameters: [...tempModelParameters]});
        }
    }



    return (
        <div className="col-12">
            <Heading size={2}>Template Basics</Heading>
            <p className="a-muted-text l-mb-sm">These are the essentials for creating a chat template.</p>
            <div className="o-block">
                {/* The title field */}
                <FormField
                    id="title"
                    label="Title"
                    type="text"
                    value={chatTemplate?.title}
                    onChange={(e) => updateData(e)}
                    required
                />
                
                {/* Description */}
                <FormField
                    id="description"
                    label="Description"
                    type="textarea"
                    rows={3}
                    value={chatTemplate?.description}
                    onChange={(e) => updateData(e)}
                    description="Show the user a brief synopsis of what the template accomplishes."
                    placeholder="Using basic requirements, create a detailed job requirement form."
                />
                
                {/* Initial Assistant Message */}
                <FormField
                    id="initialMessageText"
                    label="Initial Assistant Message"
                    type="textarea"
                    rows={6}
                    value={chatTemplate?.initialMessageText}
                    onChange={(e) => updateData(e)}
                    description="Start the chat with an optional message from the assistant to help provide context and guidance to the user."
                    placeholder="Hello! Let's get started by getting more information about your situation."
                />
                
                {/* Prompt */}
                <FormField
                    id="messageComponents"
                    label="Prompt"
                    type="textarea"
                    rows={6}
                    value={prompt}
                    onChange={(e) => updatePrompt(e.target.value)}
                    description="Add placeholders to your prompt that users can fill in. Use [brackets] for short text responses, [[double brackets]] for longer responses, and {curly brackets} for dropdown options. To set a default option in a dropdown, add an asterisk: {Option 1*, Option 2}."
                    placeholder="I currently am having troubles with [difficult area]. Can you help?"
                />
                
                {/* File Upload Checkbox */}
                <FormField
                    id="hasFileUpload"
                    label="Allow users to attach files to the prompt."
                    type="checkbox"
                    value={chatTemplate?.hasFileUpload}
                    onChange={updateCheckbox}
                />
                
                { chatTemplate?.hasFileUpload &&
                    <FormField
                        id="fileUploadMessage"
                        label="File Upload Message"
                        type="text"
                        value={chatTemplate?.fileUploadMessage}
                        onChange={(e) => updateData(e)}
                        placeholder="Choose file or drag files here to include files with the message."
                    />
                }
                
                {/* Tags Editor Component */}
                <TagsEditor 
                    chatTemplate={chatTemplate}
                    setChatTemplate={setChatTemplate}
                    trackPropertyChange={trackPropertyChange}
                />
                {/* Advanced Settings Component */}
                <AdvancedSettings 
                    chatTemplate={chatTemplate}
                    setChatTemplate={setChatTemplate}
                    models={models}
                    updateData={updateData}
                    updateModelParameters={updateModelParameters}
                />
            </div>
        </div>
    );
}

export default TemplateBasics;


//The skills stuff for a later implementation: 

{/* <div class="row l-mt-sm">
                        <div class="col-12">
                            <Heading size={3}>Skills</Heading>
                            <p class="a-muted-text a-subtle-text">Choose which skills you would like the assistant to be able to use when responding to the user's first message.</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="o-block">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="a-checkbox">
                                            <span>Web Browsing</span>
                                            <input type="checkbox" checked />
                                            <div className="b-input"></div>
                                        </label>
                                        <label className="a-checkbox">
                                            <span>Image Creation</span>
                                            <input type="checkbox" checked />
                                            <div className="b-input"></div>
                                        </label>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="a-checkbox">
                                            <span>File Reading</span>
                                            <input type="checkbox" checked />
                                            <div className="b-input"></div>
                                        </label>
                                        <label className="a-checkbox">
                                            <span>Code Interpreter/Data Analysis</span>
                                            <input type="checkbox" checked />
                                            <div className="b-input"></div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}